<template>
  <div>
    <a-row class="topTitle" type="flex" align="middle">
      <a-col :span="14" class="item-left">
        <div class="li">
          <p class="first_p">余额:</p>
          <p>{{ accountList.afterBalance }}</p>
        </div>
        <div class="li">
          <p class="first_p">出票:</p>
          <p>{{ accountList.ticketBalance }}</p>
        </div>
      </a-col>
      <a-col :span="10" class="item-right">
        <!-- <div class="rechargeBtn">
          <img src="@assets/img/chongzhi.png" alt="" />
          <span>充值</span>
        </div> -->
      </a-col>
    </a-row>
    <!-- 选择日期 -->
    <a-row>
      <a-col :span="17" class="chooseDate">
        <div class="search_content">
          <img src="@assets/img/calendar2.png" />
          <a-range-picker
            v-model:value="pickerDate"
            separator="至"
            valueFormat="YYYY-MM-DD"
            @change="dateChange"
          />
        </div>
        <a-select
          mode="multiple"
          v-model:value="changeTypeArr"
          style="width: 250px; margin-left: 18px"
          :showArrow="true"
          placeholder="请选择"
          @change="handleChange"
        >
          <template #suffixIcon><CaretDownOutlined /></template>
          <a-select-option v-for="item in searchName" :key="item.value">
            {{ item.text }}
          </a-select-option>
        </a-select>
        <a-button @click="batchDownload">
          <a  class="handleBtn">
            导出流水
          </a>
        </a-button>
      </a-col>
    </a-row>
    <!--  -->
    <a-spin :spinning="loadingTag">
      <div class="amount-list" v-if="amountList.length">
        <div
          v-for="(item, index) in amountList"
          :key="index"
          class="item_content"
        >
          <a-row class="item">
            <a-col :span="16" class="item-left">
              <div class="info">
                <span v-if="item.orderCode"
                  >单号：<span
                    class="orderCode_span"
                    @click="toDetail(item.orderCode)"
                    >{{ item.orderCode }}</span
                  ></span
                >
                <span v-else>充值订单</span>
                <br />
                <span>时间：{{ item.createTime }}</span>
              </div>
            </a-col>
            <a-col :span="4">
              <div class="changeType">{{ item.changeTypeValue }}</div>
            </a-col>
            <a-col :span="4" class="item-right">{{ item.amountValue }}</a-col>
          </a-row>
        </div>
        <!-- 分页 -->
      </div>
      <a-empty
        :description="'～没有更多了～'"
        v-show="!amountList.length && !loadingTag"
        style="margin-top: 200px"
      />
      <a-pagination
        v-show="amountList.length"
        v-model:current="current"
        :total="total"
        :page-size="10"
        @change="pageChange"
        :show-total="
          (total, range) => `第${range[0]}条 - 第${range[1]}条  共 ${total} 条`
        "
      />
    </a-spin>
  </div>
</template>
<script>
import { ref, watch } from 'vue'
import commonApi from '@axios/common'
import { useRouter, useRoute } from 'vue-router'
import myApi from '@axios/my'
import { CaretDownOutlined } from '@ant-design/icons-vue'
import {exportOut} from "@axios/exportOut";

export default {
  name: 'amountList',
  components: {
    CaretDownOutlined
  },
  setup () {
    let router = useRouter()
    const route = useRoute()

    // 日期
    let pickerDate = ref([])
    const dateChange = (date) => {
      getAmountList()
    }

    let loadingTag = ref(false)

    let amountList = ref([])
    let accountList = ref({})

    let current = ref(1)
    let total = ref(0)
    let searchName = ref({})
    let changeTypeArr = ref([])
    let changeTypes = ref('')
    searchName.value = [
      // {
      //   value: 0,
      //   text: '不限'
      // },
      {
        value: 10,
        text: '充值'
      },
      {
        value: 30,
        text: '出票'
      },
      {
        value: 40,
        text: '退票'
      }
    ]
    const handleChange = (value) => {
      console.log(`selected ${value}`)
      changeTypes.value = `${value}`
      console.log(changeTypes.value)
      getAmountList()
    }

    const getAmountList = () => {
      if (loadingTag.value) {
        return
      }
      let params = {
        size: 10,
        currentPage: current.value,
        changeTypes: changeTypes.value,
      }
      if (pickerDate.value.length) {
        params.startTime = pickerDate.value[0]
        params.endTime = pickerDate.value[1]
      }
      loadingTag.value = true
      myApi.getAccountList(params).then((res) => {

        accountList.value = res
        if (res.pageResult) {
          amountList.value = res.pageResult.data
          current.value = res.pageResult.currentPage
          total.value = res.pageResult.total

        } else {
          amountList.value = []
          current.value = 1
          total.value = 0
        }

        loadingTag.value = false
      }).catch(() => {
        loadingTag.value = false
      })
    }


    const pageChange = (page) => {
      current.value = page
      getAmountList()
    }

    const toDetail = (code) => {
      router.push({
        name: 'orderDetail',
        query: {
          orderCode: code
        }
      })
    }

    const batchDownload = () => {
      let params = {
        changeTypes: changeTypes.value,
      }
      if (pickerDate.value.length) {
        params.startTime = pickerDate.value[0]
        params.endTime = pickerDate.value[1]
      }

      let fileName = '资金流水';
      exportOut(
          params, // 导出请求参数
          "/business-account/account/flow/list/download", // 接口地址
          fileName // 导出文件名字
      );
    }


    getAmountList()



    return {
      toDetail,
      pageChange,
      total,
      accountList,
      amountList,
      loadingTag,
      pickerDate,
      dateChange,
      current,
      searchName,
      changeTypeArr,
      changeTypes,
      handleChange,
      batchDownload
    }
  },

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.search_content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.orderCode_span {
  // color:#0D6DBF;
  cursor: pointer;
}
.changeType {
  font-size: 14px;
  font-family: PingFangSC-Light, PingFang SC;
  // font-weight: 600;
  color: #000000;
}
.first_p {
  font-size: 14px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000;
}
.topTitle {
  background: #f8f8f8;
  padding: 8px 22px 7px 0;
  margin-bottom: 12px;
  .li {
    display: inline-block;
    width: 172px;
    padding-left: 18px;
    &:first-of-type {
      border-right: 0.5px solid #cdcccd;
    }
    p {
      margin: 0;
    }
  }
  .item-right {
    text-align: right;
    font-size: 14px;
    height: 23px;
    .rechargeBtn {
      display: inline-block;
      padding: 0 11px 0 8px;
      color: #fff;
      background: #fd5739;
      border-radius: 15px;
      span {
        vertical-align: text-top;
      }
      img {
        margin-right: 2px;
        vertical-align: middle;
      }
    }
  }
}
.chooseDate {
  display: flex;
  justify-content: flex-start;

  img {
    width: 20px;
    margin-right: 10px;
    vertical-align: middle;
  }
  .ant-calendar-picker {
    width: 216px;
  }
}
.item_content {
  padding: 0 16px 0 20px;
}
.item_content:hover {
  background: #e6f7ff !important;
}
.amount-list {
  margin-top: 13px;
  // padding: 0 16px 0 20px;
  border: 0.5px solid #dbdce0;
  padding: 6px 0;
  // padding-bottom: 250px;
  .item {
    padding: 15px 0 6px 0;
    border-bottom: 1px solid #dbdce0;
    .item-left {
      & div {
        display: inline-block;
      }
      .changeType {
        vertical-align: top;
        font-size: 14px;
        line-height: 22px;
        margin-right: 22px;
      }
      .info {
        color: #000000;
        font-family: PingFangSC-Light, PingFang SC;
        font-size: 14px;
        line-height: 20px;

        & span:nth-of-type(2) {
          font-family: PingFangSC-Light, PingFang SC;
          color: #929395;
        }
      }
    }
    .item-right {
      text-align: right;
      font-size: 16px;
      line-height: 22px;
      color: #929395;
    }
  }
  .item_content:last-of-type {
    .item {
      border: none;
    }
  }
  .ant-pagination {
    text-align: center;
    margin-top: 40px !important;
  }
}
</style>
